import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { S as SecondaryView } from '../SecondaryView/SecondaryView-BHYoOimJ.js';
import { S as SelectList } from '../SelectList/SelectList-CKJ1ZhdU.js';
import { D as DropdownDivider } from '../SelectList/SelectOptionGroup/SelectOptionGroup.styles-DieCzSoN.js';
import { u as useDropdownContext } from './DropdownContext-Cjb3JGE6.js';
import { F as Flex } from '../Flex/Flex-DZMfgrzg.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { s as scrollIntoBounds } from '../LocalModules/storm-ui-utils/dist/esm/scrollIntoBounds/scrollIntoBounds-Dhl2O567-Dhl2O567.js';

const DropdownSecondaryView = withTaktFallbackId(SecondaryView);
const ContentWrapper = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1glfm6m-0"
})(["height:100%;"]);
const ScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-1glfm6m-1"
})(["flex:1;overflow:auto;padding:", ";margin-top:1px;"], ({
  theme
}) => theme.spacing.small.mobile);
const MobileContainer = ({
  isOpen,
  onClose,
  secondaryViewCloseButtonLabel,
  children,
  trigger,
  anchorEl,
  preRender,
  postRender,
  onChange,
  selectedValue,
  focusSelectOption
}) => {
  const {
    multiple,
    listboxProps
  } = useDropdownContext();
  const selectListWrapperRef = useRef(null);
  useLayoutEffect(() => {
    if (!isOpen) return undefined;
    const scrollSelectedIntoView = () => {
      if (selectListWrapperRef.current) {
        const selectedOption = selectListWrapperRef.current.querySelector('button[aria-selected="true"]');
        if (selectedOption) {
          scrollIntoBounds(selectListWrapperRef.current, selectedOption);
          return true;
        }
      }
      return false;
    };
    if (scrollSelectedIntoView()) return undefined;
    const timeoutId = setTimeout(scrollSelectedIntoView, 50);
    return () => clearTimeout(timeoutId);
  }, [isOpen]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownSecondaryView, {
    isOpen: isOpen,
    onClose: onClose,
    toggleEl: anchorEl,
    padding: "none",
    closeButtonLabel: secondaryViewCloseButtonLabel,
    taktFallbackId: "dropdown-mobile"
  }, /*#__PURE__*/React__default.createElement(ContentWrapper, {
    direction: "column",
    alignItems: "inherit"
  }, preRender && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, preRender(), /*#__PURE__*/React__default.createElement(DropdownDivider, null)), /*#__PURE__*/React__default.createElement(ScrollContainer, _extends({}, listboxProps, {
    ref: selectListWrapperRef
  }), /*#__PURE__*/React__default.createElement(SelectList, {
    selectedValue: selectedValue,
    onChange: onChange,
    multiple: multiple,
    mobileFullScreen: true
  }, children), postRender === null || postRender === void 0 ? void 0 : postRender()))), trigger());
};

// @TODO: (storm-v4) revisit after design completed

export { MobileContainer as M };
//# sourceMappingURL=DropdownMobileContainer-DU21fvJZ.js.map
